module.exports = __webpack_public_path__ + "media/images/weather/66_day_g-32f23e5dce4a3152503c7a260f6c4ecf.png";